export default __webpack_public_path__ + "static/image-29-3c55c48aad87e9b39f23687d19686329.jpg";